import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

const fmtDay = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });

const current = (row) => (row.followup_invite === "off" ? "off" : row.followup_invite_on ? `date:${row.followup_invite_on}` : "default");

const parseValue = (v) => (v.startsWith("date:") ? ["date", v.slice(5)] : [v, null]);

const successMsg = (mode, date) => {
  if (mode === "off") return "Follow-up invite turned off";
  if (mode === "date") return `Invite will go out on ${fmtDay(date)}`;
  return "Invite set to 6 weeks after the visit";
};

const DoneStatus = ({ row }) => (
  <span data-testid={`followup-status-${row.id}`} className="text-xs text-ink-muted">{row.followup_invite === "sent" ? "Invite sent" : "Not needed (rebooked)"}</span>
);

const DateOptions = ({ row, dates }) => {
  const savedDate = row.followup_invite_on && !(dates || []).includes(row.followup_invite_on) ? [row.followup_invite_on] : [];
  return (
    <>
      {[...savedDate, ...(dates || [])].map((d) => <option key={d} value={`date:${d}`}>On {fmtDay(d)}</option>)}
      {dates === null && <option disabled>Loading open dates…</option>}
      {dates && dates.length === 0 && <option disabled>No open dates for this consultant</option>}
    </>
  );
};

export const FollowUpControl = ({ row }) => {
  const [value, setValue] = useState(current(row));
  const [dates, setDates] = useState(null);
  const [busy, setBusy] = useState(false);

  if (row.followup_invite === "sent" || row.followup_invite === "skipped") return <DoneStatus row={row} />;

  const loadDates = () => {
    if (dates) return;
    api.get(`/admin/bookings/${encodeURIComponent(row.id)}/followup-dates`).then(({ data }) => setDates(data.dates))
      .catch((e) => { setDates(null); toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't load open dates."); });
  };

  const change = async (v) => {
    const prev = value;
    setValue(v); setBusy(true);
    const [mode, date] = parseValue(v);
    try {
      await api.put(`/admin/bookings/${encodeURIComponent(row.id)}/followup`, { mode, date });
      Object.assign(row, { followup_invite: mode === "off" ? "off" : null, followup_invite_on: mode === "date" ? date : null });
      toast.success(successMsg(mode, date));
    } catch (e) {
      setValue(prev);
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <select value={value} disabled={busy} onFocus={loadDates} onMouseDown={loadDates} onChange={(e) => change(e.target.value)}
      data-testid={`followup-select-${row.id}`} title="When to email this patient an invitation to book a follow-up"
      className="max-w-[220px] rounded-sm border border-stone-300 bg-white px-2 py-1 text-xs">
      <option value="default">6 weeks after visit</option>
      <option value="off">Don&apos;t send</option>
      <DateOptions row={row} dates={dates} />
    </select>
  );
};
